
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/session/[session_id]",
      function () {
        return require("private-next-pages/session/[session_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/session/[session_id]"])
      });
    }
  